/*
 * @Author: WGL 958897276@qq.com
 * @Date: 2025-04-07 09:22:33
 * @LastEditors: WGL 958897276@qq.com
 * @LastEditTime: 2025-04-07 10:19:25
 * @FilePath: /erp-admin/src/utils/icon.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import iconConfig from '@/iconfont/iconfont.json'
export function handleGetCustomIcon() {
  const iconObj = {}
  const css_prefix_text = iconConfig.css_prefix_text
  iconConfig.glyphs.forEach((item) => {
    const key = `${css_prefix_text}${item.font_class}`
    iconObj[key] = item.name
  })
  //   console.log('iconObj :>> ', iconObj)
  return iconObj
}
